import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2025 from '../SchoolProgram2023/components/Sidebar2025';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const SocialandEmotional = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/8.webp`;
    const p9 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/9.webp`;
    const p10 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/10.webp`;
    const p11 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/11.webp`;
    const p12 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/12.webp`;
    const p13 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/13.webp`;
    const p14 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/14.webp`;
    const p15 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/15.webp`;
    const p16 = `${config.base_image_url_2026}/home/events-activities/school-programs/ScienceExhibition2026/16.webp`;

    const photos = [
       
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
         {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
         {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
         {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
         {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
         {
            src: p9,
            source: p9,
            rows: 1,
            cols: 1,
        },
         {
            src: p10,
            source: p10,
            rows: 1,
            cols: 1,
        },
         {
            src: p11,
            source: p11,
            rows: 1,
            cols: 1,
        },
         {
            src: p12,
            source: p12,
            rows: 1,
            cols: 1,
        },
         {
            src: p13,
            source: p13,
            rows: 1,
            cols: 1,
        },
         {
            src: p14,
            source: p14,
            rows: 1,
            cols: 1,
        },
         {
            src: p15,
            source: p15,
            rows: 1,
            cols: 1,
        },
         {
            src: p16,
            source: p16,
            rows: 1,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               SCIENCE EXHIBITION 
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                  Date: 31st August 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                               <Typography variant={'subtitle1'} align={'justify'}>
Our school organized an exciting Science Exhibition on 31st August 2026, providing students with a
wonderful platform to showcase their scientific knowledge, creativity, and innovative ideas.
The exhibition witnessed enthusiastic participation from students across various classes. A wide range of
projects and working models were displayed, covering areas such as renewable energy, environmental
conservation, robotics, space science, health and technology, and everyday applications of science.
The event was inaugurated by the school Principal and witnessed by teachers, students, and invited guests.
The young scientists confidently explained their models and demonstrated the working of their projects.
Their enthusiasm, creativity, and ability to connect scientific concepts with real-life situations were highly
appreciated.
  <br></br>

The exhibition aimed to encourage scientific thinking, curiosity, innovation, teamwork, and problem-
solving skills among students. It also provided them with an opportunity to move beyond textbooks and
experience the practical application of scientific principles.
The event was a great success and received an enthusiastic response from everyone. The Science
Exhibition not only celebrated the students’ creativity and hard work but also inspired them to explore new
ideas and contribute towards a better and more sustainable future.
The exhibition concluded on a positive note, leaving students motivated to continue their journey of
discovery, innovation, and scientific exploration.
  
        <br></br>

</Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
”Science of today is technology for tomorrow”
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default SocialandEmotional;